import React, { ChangeEvent } from "react";
import { Label } from "./_fieldStyles";
import * as FormControlModule from "@mui/material/FormControl/index.js";
import * as FormHelperTextModule from "@mui/material/FormHelperText/index.js";
import * as FormLabelModule from "@mui/material/FormLabel/index.js";
import { resolveDefault } from "../../utils/moduleInterop";

const FormControl = resolveDefault<any>(FormControlModule);
const FormHelperText = resolveDefault<any>(FormHelperTextModule);
const FormLabel = resolveDefault<any>(FormLabelModule);

type RadioButtonFieldProps = {
	label?: string;
	name: string;
	value?: string;
	error?: string;
	disabled?: boolean;
	handleBlur?: () => void;
	options?: string[];
	helperText?: string;
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const RadioButtonField: React.FC<RadioButtonFieldProps> = ({
	label = "Radio",
	name = "",
	value,
	error = "",
	disabled,
	handleBlur,
	options = ["Option 1", "Option 2"],
	helperText = "Helper text",
	onChange,
}) => {
	// Use a no-op handler if onChange is not provided to avoid React warning
	// about controlled input without onChange handler
	const handleChange = React.useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			if (onChange) {
				onChange(e);
			}
		},
		[onChange],
	);

	return (
		<>
			<FormControl component="fieldset">
				<FormLabel component="legend">{label}</FormLabel>

				{options.map((opt, index) => (
					<Label key={index}>
						<input
							type="radio"
							name={name}
							value={opt}
							checked={opt === value}
							onBlur={handleBlur}
							onChange={handleChange}
							disabled={disabled}
						/>
						{opt}
					</Label>
				))}
			</FormControl>

			<FormHelperText>{helperText}</FormHelperText>

			{error && <FormHelperText error={true}>{error}</FormHelperText>}
		</>
	);
};

export default RadioButtonField;
